import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, Zone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  duplicateProject(request: Boundaries["duplicateProject"]["request"]): void;
}

function useDuplicateProject(
  zone: Identifiable<Zone>,
  sourceProject: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isDuplicateProjectRequestPending(sourceProject, zone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isDuplicateProjectRequestSuccess(sourceProject, zone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isDuplicateProjectRequestFailure(sourceProject, zone),
    ),
    duplicateProject: core.duplicateProject,
  };
}

export { useDuplicateProject };
